<template>
  <div class="thanksPage">
      <p class="u-color-black e-paragraph">Les votes sont clos.<br>
      La série gagnante sera révélée le 13 octobre lors de <br>la Cérémonie de Clôture du Festival.</p>
  </div>
</template>

<script>

export default {
  components: {
  },
};
</script>

<style lang="scss">
.thanksPage {
    max-width: 600px;
    margin:auto;
    p {
        text-align: center;
        padding-bottom: var(--spacing-l);
        padding-top: 20px;

      @include media('>=m') {
        padding-top: 75px;
      }
    }
}
</style>
